import { absolutePath } from "./absolutePath";

interface PaywallGroupFnProps {
  params?: Record<string, unknown>;
  paywallGroupId?: string | number;
}

export const paywallGroup = {
  index: ({ params = {} }: PaywallGroupFnProps = {}) =>
    absolutePath("paywalls/groups", params),
  create: ({ params = {} }: PaywallGroupFnProps = {}) =>
    absolutePath("paywalls/groups/", params),
  update: ({ paywallGroupId, params = {} }: PaywallGroupFnProps = {}) =>
    absolutePath(`paywalls/groups/${paywallGroupId}`, params),
  show: ({ paywallGroupId }: PaywallGroupFnProps) =>
    absolutePath(`paywalls/groups/${paywallGroupId}`),
};
